<template>
  <div>
    <section id="app" class="section pt-1 bg-white">
      <div class="container">
        <h1 class="media mb-5">
          <div class="avatar-sm mr-3">
            <span
              class="
                avatar-title
                rounded-circle
                bg-soft-info
                text-info
                font-size-28
              "
            >
              <i class="bx bx-compass"></i>
            </span>
          </div>
          {{ $t("help.title") }}
        </h1>

        <b-row>
          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/screen-panel">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.screen-panel.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>
          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/account-info">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.account.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/roadmap">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.roadmap.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/announcement">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.announcement.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>
          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/organization-settings">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.organization-settings.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/organization-members">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.organization-members.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/thirdparty">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.thirdparty.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>
          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/application">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.application.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/hierarchy">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.organization-hierarchy.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/asset-group">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.asset-group.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>
          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/inventory">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.inventory.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/data-breach">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.data-breach.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/risk">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.risk.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/policy">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.policy.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/task">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.task.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/questionset-survey">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.questionset-survey.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/legal-document">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.legal-document.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/report">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.report.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>

          <b-col lg="4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <div>
                <router-link to="/help-center/platform/file-manager">
                  <h5 class="my-0 text-primary">
                    {{ $t("help.platform.file-manager.text") }}
                    <i class="fa fa-arrow-right float-right"></i>
                  </h5>
                </router-link>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
